// extracted by css-extract-rspack-plugin
export default {"root":"GeneralTabPanel_root__2ISxh","mobile":"GeneralTabPanel_mobile__qdvkI"};